const bgCircles = [1313, 1175, 1043, 905, 783, 675, 564, 453, 347, 249, 161];
const mobileBgCircles = [320, 380, 440, 500, 560, 620, 700, 760];

const whyFds = {
    title: 'Why <span class="p3-semibold md:h3-semibold">Fixed Deposits?</span>',
    steps: [
        {
            title: 'Guaranteed Returns',
            description: 'No surprises, just steady growth',
            icon: 'guarantee-returns',
        },
        {
            title: 'Loan Against FD',
            description: 'Need cash? Use your FD as collateral and get a loan',
            icon: 'loan',
        },
        {
            title: 'Auto-renewal',
            description:
                'Set it and forget it. Your FD renews automatically, so you never miss out on interest',
            icon: 'auto-renewal',
        },
        {
            title: 'Low Risk',
            description:
                'Sleep easy, knowing your investment is safe and secure',
            icon: 'low-risk',
        },
    ],
};

const fdCarouselContent = {
    title: 'Fixed Deposits are a <span class="p3-semibold md:h3-semibold">secure and<br class="md:hidden"/> stable</span> way to <span class="p3-semibold md:h3-semibold">grow your money</span>',
    description: 'Choose an FD of your choice',
    cards: [
        {
            name: 'Utkarsh Small Finance Bank',
            returns: '9.1%',
            bg: 'linear-gradient(0deg, #FFF 60.18%, #F0DEFF 100%)',
            icon: 'usfb',
        },
        {
            name: 'Suryoday Small Finance Bank ',
            returns: '9.1%',
            bg: 'linear-gradient(0deg, #FFF 60.18%, #FFE6D1 100%)',
            icon: 'ssfb',
        },
        {
            name: 'Shivalik SF Bank',
            returns: '9.05%',
            bg: 'linear-gradient(0deg, #FFF 60.18%, #EBFFE4 100%)',
            icon: 'ssb',
        },
        {
            name: 'North East SF Bank',
            returns: '9%',
            bg: ' linear-gradient(0deg, #FFF 60.18%, #FFEBEB 100%)',
            icon: 'nesb',
        },
        {
            name: 'Shriram Finance',
            returns: '8.97%',
            bg: 'linear-gradient(0deg, #FFF 60.18%, #FFF7DD 100%)',
            icon: 'sf',
        },
        {
            name: 'Bajaj Finance',
            returns: '8.65%',
            bg: 'linear-gradient(0deg, #FFF 60.18%, #D4EDFF 100%)',
            icon: 'bf',
        },
        {
            name: 'South Indian Bank',
            returns: '7.9%',
            bg: 'linear-gradient(0deg, #FFF 60.18%, #FFE0E1 100%)',
            icon: 'sindb',
        },
    ],
};

const fdReturnsCalculator = {
    title: 'FD returns calculator',
    description:
        'Key in details like investment amount, interest rate and tenure to calculate your maturity amount.',
    disclaimer: 'Disclaimer: For calculation purposes, we assume that the interest on your Fixed Deposit is compounded quarterly.',
    inputs: [
        {
            id: 'investmentAmount',
            label: 'Total Investment',
            type: 'number',
            min: 1000,
            max: 10000000,
            step: 50,
            defaultValue: 10000,
            prefix: '₹',
        },
        {
            id: 'interestRate',
            label: 'Rate of Interest (p.a.)',
            type: 'number',
            min: 1,
            max: 12,
            step: 0.1,
            defaultValue: 6.5,
            suffix: '%',
        },
        {
            id: 'tenure',
            label: 'Time period in years',
            type: 'number',
            min: 1,
            max: 25,
            step: 1,
            defaultValue: 1,
        },
    ],
    results: [],
    button: 'Book FD Now',
};

const fdBookingSteps = {
    title: 'Book your FD in just <span class="p2-semibold md:h3-semibold">4 steps</span>',
    steps: [
        {
            step: '01',
            description:
                'Pick an FD of your choice <br class="hidden md:inline-block"/> from a range of options',
        },
        {
            step: '02',
            description:
                'Select investment amount,<br class="hidden md:inline-block"/> tenure and maturity',
        },
        {
            step: '03',
            description:
                'Complete your KYC and<br class="hidden md:inline-block"/> review investment<br class="hidden md:inline-block"/> details',
        },
        {
            step: '04',
            description:
                'Transfer the amount to<br class="hidden md:inline-block"/> complete <br class="hidden md:inline-block"/>your investment',
        },
    ],
    note: 'You can track your investments on your FD dashboard',
    button: 'Book FD Now',
};

const fdCompareContent = {
    title: 'Compare India’s best FD rates offered by public sector and private sector banks',
    description: 'FD Interest Rates - 1 Year and 3 Years',

    tableData: [
        {
            bank: 'Axis Bank',
            logo: 'Axis',
            year1: '6.70% p.a.',
            year3: '7.10% p.a.',
        },
        {
            bank: 'Bandhan Bank',
            logo: 'BandhanBank',
            year1: '8.05% p.a.',
            year3: '7.25% p.a.',
        },
        {
            bank: 'Bank of Baroda',
            logo: 'Bob',
            year1: '6.85% p.a.',
            year3: '7.15% p.a.',
        },
        {
            bank: 'Central Bank of India',
            logo: 'Cbi',
            year1: '6.85% p.a.',
            year3: '7.25% p.a.',
        },
        {
            bank: 'HDFC Bank',
            logo: 'Hdfc',
            year1: '6.60% p.a.',
            year3: '7.00% p.a.',
        },
        {
            bank: 'ICICI Bank',
            logo: 'Icici',
            year1: '6.00% p.a.',
            year3: '7.00% p.a.',
        },
        {
            bank: 'IDBI Bank',
            logo: 'Idbi',
            year1: '6.80% p.a.',
            year3: '6.50% p.a.',
        },
        {
            bank: 'IDFC FIRST Bank',
            logo: 'Idfc',
            year1: '6.50% p.a.',
            year3: '6.80% p.a.',
        },
        {
            bank: 'IndusInd Bank',
            logo: 'IndusInd',
            year1: '7.75% p.a.',
            year3: '7.25% p.a.',
        },
        {
            bank: 'Karnataka Bank',
            logo: 'Kab',
            year1: '7.25% p.a.',
            year3: '6.50% p.a.',
        },
        {
            bank: 'Kotak Mahindra Bank',
            logo: 'Kmb',
            year1: '7.40% p.a.',
            year3: '7.00% p.a.',
        },
        {
            bank: 'Punjab National Bank',
            logo: 'Pnb',
            year1: '6.80% p.a.',
            year3: '7.00% p.a.',
        },
        {
            bank: 'RBL Bank',
            logo: 'Rbl',
            year1: '7.50% p.a.',
            year3: '7.50% p.a.',
        },
        {
            bank: 'South Indian Bank',
            logo: 'Sib',
            year1: '6.70% p.a.',
            year3: '6.70% p.a.',
        },
        {
            bank: 'State Bank of India',
            logo: 'Sbi',
            year1: '6.80% p.a.',
            year3: '7.00% p.a.',
        },
        {
            bank: 'Tamilnadu Mercantile Bank',
            logo: 'Tmb',
            year1: '7.00% p.a.',
            year3: '6.50% p.a.',
        },
        {
            bank: 'UCO Bank',
            logo: 'Uco',
            year1: '6.50% p.a.',
            year3: '6.30% p.a.',
        },
        {
            bank: 'Union Bank of India',
            logo: 'Ub',
            year1: '6.80% p.a.',
            year3: '6.70% p.a.',
        },
        {
            bank: 'YES Bank',
            logo: 'yes',
            year1: '7.25% p.a.',
            year3: '7.25% p.a.',
        },
    ],
    note1: '(Data as of Feb 2025. Rates are subjected to change with bank discretion)',
    note2: 'Note: Senior Citizens get slightly higher interest rates ranging between 0.25% -0.50% p.a. depending on the FD tenure.',
};

const fdFAQContent = {
    title: 'Frequently Asked Questions',
    faqs: [
        {
            question: 'What Is a Fixed Deposit and How Does It Work?',
            answer: 'A fixed deposit lets you invest a lump sum for a fixed tenure at a guaranteed interest rate. You earn interest on your deposit, which compounds over time, and you receive both the principal and accumulated interest at maturity. Banks and financial institutions offer FDs as a low-risk investment option, making them ideal for achieving financial goals with certainty.',
        },
        {
            question: 'Do you need an FD in your portfolio?',
            answer: 'Even though there are a lot of other options in the market, FDs offer you guaranteed returns with lower risk. They preserve your capital, offer liquidity and predictable interest, and balance market-linked investments. Since they might not always beat inflation, you can just as conveniently use FDs for short-term goals or building emergency funds. For growth, you can diversify with some higher-yield options, but it is always a smart idea to balance your portfolio’s risk with FDs.',
        },
        {
            question:
                'What Are the Different Types of Fixed Deposit Accounts Available?',
            answer: 'Providers offer various FD types, like standard FDs with fixed returns, tax-saving FDs qualifying for Section 80C deductions, and senior citizen FDs, granting higher interest rates. Flexi FDs link to your savings account for automatic investments, while NRI FDs cater to non-resident Indians. You can choose the type that aligns with your financial objectives.',
        },
        {
            question:
                'What Is the Minimum and The Maximum Tenure for A Fixed Deposit?',
            answer: 'Fixed deposits come with tenures from 7 days to 10 years. Short-term FDs provide liquidity for immediate needs, while long-term FDs maximize returns through compounding. You should select a comfortable tenure that matches your financial goals.',
        },
        {
            question: 'What is the eligibility criteria for opening an FD?',
            answer: 'You can open an FD account as long as you are a citizen of India (resident or non-resident), any company, partnership firm, business, senior citizen or minor etc. You will need some basic documents like proof of identity, proof of address, and proof of date of birth. Please note that the detailed process and documentation can differ for different providers.',
        },
    ],
};

export {
    bgCircles,
    mobileBgCircles,
    whyFds,
    fdCarouselContent,
    fdBookingSteps,
    fdCompareContent,
    fdReturnsCalculator,
    fdFAQContent,
};
